import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=f1336782&scoped=true"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=f1336782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1336782",
  null
  
)

export default component.exports